export default "__VITE_ASSET__36f925cd__"